<template>
    <div class="modal">
        <input :id="'modal_'+id" type="checkbox" />
        <label :for="'modal_'+id" class="overlay"></label>
        <article>
            <header>
                <h3>
                    {{ title }}
                </h3>
                <label :for="'modal_'+id" class="close">&times;</label>
            </header>
            <section class="content">
                <slot></slot>
            </section>
            <footer>
                <slot name="buttons"></slot>
            </footer>
        </article>
    </div>
</template>

<script>
  export default {
      props: [
          'title',
      ],
      data () {
          return {
              id: null
          }
      },
      created () {
          this.id = 'id-'+Math.random().toString(36).slice(2)
      },
      methods: {
        show () {
            document.getElementById('modal_' + this.id).checked = true
        },
        hide () {
            document.getElementById('modal_' + this.id).checked = false
        }
    }
}
</script>

<style lang="less" scoped>
    
</style>